import { createFileRoute } from "@tanstack/react-router";
import { KeyRoundIcon, ShieldCheckIcon } from "lucide-react";
import { EnvVarList } from "@/components/admin/env-var-list";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/integrations")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities),
  component: AdminIntegrationsPage,
});

function AdminIntegrationsPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          <KeyRoundIcon className="size-3.5" />
          Configuration
        </div>
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div className="flex flex-col gap-1">
            <h1 className="font-heading text-3xl font-semibold tracking-tight">
              Secrets &amp; Variables
            </h1>
            <p className="max-w-2xl text-sm text-muted-foreground">
              Environment variables and secrets that HR Docket reads at runtime. Values are
              encrypted at rest in the platform database.
            </p>
          </div>
          <div className="flex items-center gap-2 rounded-md border border-emerald-200/60 bg-emerald-50/60 px-3 py-1.5 text-xs text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300">
            <ShieldCheckIcon className="size-3.5" />
            Encrypted at rest
          </div>
        </div>
      </header>

      <EnvVarList />
    </div>
  );
}
